import {OrpyxRoleType} from "admins-dashboard/http-clients/index";

export class AdminExportRawDataPolicies {
    static readonly Allow = [OrpyxRoleType.Audit, OrpyxRoleType.Manufacturing, OrpyxRoleType.Support];
}

export default AdminExportRawDataPolicies;
